import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import sampleIndex from './sample/samples.index.module';
import meetingList from './sample/create/meeting-list.module';
import meetingDetail from './sample/create/meeting-detail.moduel';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    sampleIndex,
    meetingList,
    meetingDetail,
  }
});
